import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const Index = ({
  handleSubmit,
  handleChange,
  loading,
  values,
  setStep,
  step,
}) => {
  const [token, setToken] = useState("");
  const siteKey = "6LdTYnknAAAAAEUBgCdOjFC3jEBb6iOldVjBdMCt";

  const handleCaptchaChange = (reCaptchaToken) => setToken(reCaptchaToken);

  return (
    <div className="w-auto justify-center items-center">
      <p className="text-sky-900 text-center text-3xl font-bold mb-6 mt-5">
        Contact Information
      </p>
      <form
        className="mx-auto max-w-xl"
        onSubmit={(e) => {
          if (token) {
            handleSubmit(e);
          } else {
            e.preventDefault();
            alert("Please verify that you are not a robot.");
          }
        }}
      >
        <div className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2">
          <div className="relative">
            <label
              htmlFor="first-name"
              className="text-sm font-bold text-sky-900 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              First Name*
            </label>
            <input
              type="text"
              name="first_name"
              id="first_name"
              autoComplete="given-name"
              className="w-full px-3.5 py-2 text-gray-800 sm:text-sm sm:leading-6 border-sky-800 border-2"
              value={values.first_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="relative">
            <label
              htmlFor="last-name"
              className="text-sm font-bold text-sky-900 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              Last Name*
            </label>
            <input
              type="text"
              name="last_name"
              id="last_name"
              required
              autoComplete="family-name"
              className="w-full px-3.5 py-2 text-gray-800 sm:text-sm sm:leading-6 border-sky-800 border-2"
              onChange={handleChange}
              value={values.last_name}
            />
          </div>
          <div className="relative">
            <label
              htmlFor="email"
              className="text-sm font-bold text-sky-900 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              Email Address*
            </label>
            <input
              type="email"
              name="email"
              id="email"
              autoComplete="email"
              className="w-full px-3.5 py-2 text-gray-800 sm:text-sm sm:leading-6 border-sky-800 border-2"
              onChange={handleChange}
              value={values.email}
              required
            />
          </div>
          <div className="relative">
            <label
              htmlFor="phone"
              className="text-sm font-bold text-sky-900 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              Phone Number*
            </label>
            <input
              type="number"
              name="phone"
              id="phone"
              autoComplete="tel"
              className="w-full px-3.5 py-2 text-gray-800 sm:text-sm sm:leading-6 border-sky-800 border-2"
              onChange={handleChange}
              value={values.phone}
              required
            />
          </div>
          <div className="sm:col-span-2">
            <div className="mt-2.5">
              <ReCAPTCHA onChange={handleCaptchaChange} sitekey={siteKey} />
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-900">
            By clicking "Submit" you agree to allow Affordable Debt
            Consolidation to contact you by phone, SMS, or email. We never sell
            your information.
          </p>
          <div className="my-4">
            <button
              className="bg-sky-800 text-white font-bold py-3 w-40 rounded transition hover:bg-sky-900"
              disabled={loading}
              type="submit"
            >
              {loading ? (
                <div className="animate-spin rounded-full border-t-4 border-white h-6 w-6 mx-auto" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Index;
